import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import './ExpiredLinkBanner.scss';

import * as router from '@configs/routes.json';

interface ExpiredLinkBannerProps {
  packageId: string;
  packageName: string;
}

const ExpiredLinkBanner: React.FC<ExpiredLinkBannerProps> = ({
  packageId,
  packageName,
}) => {
  const { t } = useTranslation();
  return (
    <Row className='download-expired-link-container specificity'>
      <Col className='d-flex align-items-center flex-row pl-0'>
        <h6 className='m-0'>{t('downloadResultsPkg_expiredLink')}</h6>
        &nbsp;
        <a
          className='fcolor--global-white font-weight-semi-bold'
          href={`${router.app.results}?pkgId=${packageId}&pkgName=${packageName}`}
        >
          {t('downloadResultsPkg_latestResults')}&nbsp;
          <i className='fas fa-chevron-right'></i>
        </a>
      </Col>
    </Row>
  );
};

export default ExpiredLinkBanner;
